<template>
  <div class="popup-box popup-set">
    <div class="setting-wrap bg-white popup y-scroll-box">
      <button class="icon-close" @click="hideProfilePopup" />
      <div class="popup-top">
        <a class="back" @click="changeViewType('main')"><i class="icon-arrow-left-lg" /></a>
        <h2 class="tx-center popup-tit">
          {{ $t('프로필선택') }}
        </h2>
      </div>
      <div class="popup-con">
        <div class="tab">
          <a
            :class="{
              active: imageCategory === 'builtInImages',
            }"
            @click="changeImageCategory('builtInImages')"
          >{{ $t('기본제공') }}</a>
          <a
            :class="{
              active: imageCategory === 'userImages',
            }"
            @click="changeImageCategory('userImages')"
          >{{ $t('내이미지') }}</a>
        </div>
        <!-- tab-content 1,2 -->
        <div class="profile-images y-scroll-con">
          <ul>
            <li v-if="imageCategory === 'userImages'" @click="profileImageUploadInput?.click()">
              <input
                id="profileImageUploadInput"
                ref="profileImageUploadInput"
                type="file"
                accept="image/*"
                style="display: none"
                @change="uploadProfileImage"
              >
              <div class="profile-photo">
                <label class="btn-add pointer">
                  <span class="blind">Attach</span>
                </label>
              </div>
            </li>

            <li
              v-for="image in images?.userUploadImages"
              v-if="imageCategory === 'userImages'"
              :key="image.id"
              :class="{ active: image.id === selectedImageId }"
            >
              <div
                class="profile-photo"
                :style="{
                  backgroundImage: `url(${image.url})`,
                }"
                @click.self="onClickImage(image.id)"
              >
                <div class="icon-close-sm" @click.self="deleteProfileImage(image.id)" />
              </div>
            </li>
            <li
              v-for="image in images?.builtInImages"
              v-if="imageCategory === 'builtInImages'"
              :key="image.id"
              :class="{ active: image.id === selectedImageId }"
              @click="onClickImage(image.id)"
            >
              <div
                class="profile-photo"
                :style="{
                  backgroundImage: `url(${image.url})`,
                }"
              />
            </li>
          </ul>
        </div>
        <!--  -->

        <button class="single-btn btn-sky" @click="onClickComplete">
          {{ $t('선택완료') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type ImageCategory = 'builtInImages' | 'userImages'
const { $t } = useNuxtApp()
const {
  changeViewType,
  fetchUsableProfileImages,
  updateMyProfileImage,
  hideProfilePopup,
  uploadProfileImage: uploadFile,
  deleteProfileImage: deleteFile,
} = useProfile()
const { jwtCookie, profileImage } = useAuth()

const selectedImageId = ref<number | null>(profileImage.value?.id ?? null)
const profileImageUploadInput = ref<HTMLInputElement | null>(null)

const { data: images, refresh } = await fetchUsableProfileImages()

function onClickImage(imageId: number) {
  selectedImageId.value = imageId
}

const imageCategory = ref<ImageCategory>('builtInImages')

function changeImageCategory(category: ImageCategory) {
  imageCategory.value = category
}

async function onClickComplete() {
  if (selectedImageId.value) {
    const token = await updateMyProfileImage(selectedImageId.value)
    /// TODO : composable에서 고르면 왜 안되는지 알아보기
    jwtCookie.value = token.value
    changeViewType('main')
  }
  else {
    alert($t('이미지를선택해주세요'))
  }
}

async function uploadProfileImage(event: Event) {
  const target = event.target as HTMLInputElement
  const files = target.files

  if (files && files.length > 0) {
    const jwt = await uploadFile(files[0])
    if (jwt.value) {
      jwtCookie.value = jwt.value
    }
    refresh()
    selectedImageId.value = profileImage.value.id ?? null
  }
}

async function deleteProfileImage(profileImageId: number) {
  if (!confirm($t('정말삭제하시겠어요'))) {
    return
  }

  const token = await deleteFile(profileImageId)

  if (profileImage.value.id === profileImageId) {
    selectedImageId.value = images.value?.builtInImages[0].id ?? null
  }

  if (token.value) {
    jwtCookie.value = token.value
  }

  refresh()
}
</script>

<style scoped>
@import '~/assets/css/login.css';
</style>
